(function($) {
    $.fn.dailyEvents = function(settings) {
        var $container = $(settings.container);
        var interval;
        var summaryLength = 0;
        var currentIndex = 0;

        $(document).ready(function() {
            $.getJSON(settings.url, function(data) {
                if (!data || data.status !== 0) return;

                summaryLength = data.data.length;

                data.data.forEach(function(summary, index) {
                    // $(document).append();
                    var $elem = $("<span>")
                        .attr("data-index", index)
                        .html(summary);

                    if (index) $elem.css("display", "none");

                    $container.append($elem);
                });

                if (data.data && data.data.length) {
                    interval = setInterval(function() {
                        $container.find('[data-index="' + currentIndex++ + '"]').fadeOut(500, function() {
                            if (currentIndex + 1 > summaryLength) currentIndex = 0;

                            $container.find('[data-index="' + currentIndex + '"]').fadeIn(500);
                        });
                    }, 4000);
                }
            });
        });
    };
})(jQuery);
